import classNames from 'classnames';
import { DataLayerProps } from 'eco-design-micro/props/DataLayerProps';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import gtm from 'eco-design-reliance/gtm';
import EcoButton from 'eco-design/base/eco-button';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import './index.scss';

export interface EcoTabSwiperItemProps extends EcoTabItemProps, ImgVideoProps {
    /**
     * 底部内容
     */
    bottomContent?: React.ReactNode;
    /**
     * 更多按钮-内容
     */
    moreBtnContent?: React.ReactNode;
    /**
     * 更多按钮-链接
     */
    moreBtnHref?: string;
    /**
     * 更多按钮-埋点
     */
    moreBtnDataLayer?: DataLayerProps;
    /**
     * tab-埋点
     */
    tabDataLayer?: DataLayerProps;
}

export interface EcoTabSwiperProps {
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 样式名
     */
    className?: string;
    /**
     * 默认选中第几个
     */
    activeIndex?: number;
    /**
     * 点击更多
     */
    moreItemCallback?: (item: EcoTabSwiperItemProps, index: number) => void;
    /**
     * 列表
     */
    items: EcoTabSwiperItemProps[];
    gtmTitle?: string;
}

/**
 * 维护:谢保林
 *
 * tab 切换列表
 */
const EcoTabSwiper: React.FC<EcoTabSwiperProps> = ({ theme = 'white', activeIndex = 0, className, items = [], moreItemCallback, gtmTitle }) => {
    const prefixCls = `eco-tab-swiper`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });
    const defaultIndex = activeIndex || 0;
    const [activeItem, setActiveItem] = useState(items[defaultIndex] || {});
    const [selectIndex, setSelectIndex] = useState(defaultIndex);
    const [spaceBetweenW, setSpaceBetweenW] = useState(24); //左右间隔
    const tabItems = items.map((item: EcoTabSwiperItemProps) => {
        return {
            tabValue: item.tabValue,
            tabLabel: item.tabLabel,
            tabDataLayer: item.tabDataLayer,
        };
    });
    const [swiperA, setSwiperA] = useState<any>(null); // 用于点击tab时执行轮播切换
    // 轮播组件内的切换
    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        changeHandle(index);
    };
    // 点击切换
    const onTabChange = (item: EcoTabItemProps, index: number) => {
        if (index === selectIndex) {
            return;
        }
        changeHandle(index);
        swiperA.slideToLoop(index);
    };
    // 执行切换
    const changeHandle = (index: number) => {
        setSelectIndex(index);
        setActiveItem(items[index] || {});
    };
    // 更多按钮
    const moreBtnHandle = (item: EcoTabSwiperItemProps, index: number) => {
        if (moreItemCallback) {
            moreItemCallback(item, index);
        }
        try {
            const dataLayer1 = item.moreBtnDataLayer || {
                event: 'uaEvent',
                event_name: 'view_more',
                list_name: 'none',
                button_name: item.moreBtnContent,
            };
            gtm.push(dataLayer1);
        } catch (error) { }
    };
    useEffect(() => {
        const initHandle = () => {
            // 初始化间隔
            const clientWidth = document.body.clientWidth;
            if (clientWidth >= 1024) {
                setSpaceBetweenW(24);
            } else {
                setSpaceBetweenW(16);
            }
        };
        initHandle();
    }, []);
    return (
        <div className={classes}>
            <Swiper
                className={`${prefixCls}-s1`}
                slidesPerView={'auto'}
                centeredSlides
                spaceBetween={spaceBetweenW}
                navigation={{
                    nextEl: '.eco-swiper-button-next',
                    prevEl: '.eco-swiper-button-prev',
                }}
                modules={[Navigation]}
                loop={true}
                onSlideChange={handleSlideChange}
                onSwiper={(swiperIns: any) => setSwiperA(swiperIns)}
            >
                {items.map((item: EcoTabSwiperItemProps, index: number) => {
                    return (
                        <SwiperSlide key={index} className={`${prefixCls}-s1-item`}>
                            <div className={`${prefixCls}-s1-item-img`}>
                                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} pad={item.pad} h5={item.h5} alt={item.tabLabel} />
                            </div>
                            <div className={`${prefixCls}-s1-item-msg`}>
                                <div className={`${prefixCls}-s1-item-btns`}>
                                    {item.moreBtnContent && (
                                        <EcoButton
                                            lHref={item.moreBtnHref}
                                            lChildren={item.moreBtnContent}
                                            lRadius="ellipse"
                                            lSize="small"
                                            onClick={() => {
                                                moreBtnHandle(item, index);
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
            <div className={`${prefixCls}-h`}>
                <EcoTab items={tabItems} onChange={onTabChange} gtmTitle={gtmTitle} activeIndex={selectIndex} theme={theme} />
            </div>
            <div className={`${prefixCls}-c2`}>{activeItem.bottomContent}</div>
        </div>
    );
};

export default EcoTabSwiper;
